import { render } from "./selectedPanel.vue?vue&type=template&id=48817b2b"
import script from "./selectedPanel.vue?vue&type=script&lang=js"
export * from "./selectedPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__